/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Updated_NowInputs */

const en_directory_vibebids_updated_now = /** @type {(inputs: Directory_Vibebids_Updated_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated just now`)
};

const zh_directory_vibebids_updated_now = /** @type {(inputs: Directory_Vibebids_Updated_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刚刚更新`)
};

/**
* | output |
* | --- |
* | "Updated just now" |
*
* @param {Directory_Vibebids_Updated_NowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_updated_now = /** @type {((inputs?: Directory_Vibebids_Updated_NowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Updated_NowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_updated_now(inputs)
	return zh_directory_vibebids_updated_now(inputs)
});
export { directory_vibebids_updated_now as "directory.vibebids.updated_now" }